import { LoadableAfterPaint } from '@confluence/loadable';

export const BulkArchivePagesLoader = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-BulkArchivePagesLoader" */ '../src/BulkArchivePagesLoader'
			)
		).BulkArchivePagesLoader,
});
